import { Avatar } from 'lmcv/components/Avatar'
import { Card } from 'lmcv/components/Card'
import { Skeleton } from 'lmcv/components/Skeleton'

import * as S from './styled'

const ProfileSkeleton = () => (
  <Card>
    <S.Content>
      <Avatar loading />

      <S.TextContainer>
        <Skeleton width="150px" height="20px" /> <br />
        <Skeleton width="80px" height="15px" />
      </S.TextContainer>

      <S.Divider />

      <S.DateContainer>
        <Skeleton width="150px" height="20px" /> <br />
        <Skeleton width="80px" height="15px" />
      </S.DateContainer>
    </S.Content>
  </Card>
)

export default ProfileSkeleton
